import { motion } from "framer-motion";

const LOGINS = [
  {
    id: "dpemt",
    label: "Defensoria Pública MT",
    src: "https://customer-assets-v7afamib.emergentagent.net/job_guru-landing-v2/artifacts/e3io10vz_PERSONALIZADO%20DPEMT.jpg",
    accent: "#0F5C3B",
  },
  {
    id: "tremt",
    label: "TRE Mato Grosso",
    src: "https://customer-assets-v7afamib.emergentagent.net/job_guru-landing-v2/artifacts/lct3puwq_PERSONALIZADO%20TREMT.jpg",
    accent: "#2740A8",
  },
  {
    id: "palmas",
    label: "Prefeitura de Palmas",
    src: "https://customer-assets-v7afamib.emergentagent.net/job_guru-landing-v2/artifacts/c0ix0d1v_PERSONALIZADO%20PREF%20PALMAS.jpg",
    accent: "#1A3A7A",
  },
];

const EASE = [0.22, 1, 0.36, 1];

/**
 * PersonalizacaoStack — 3 personalized logins in a horizontal fan.
 * Center card sits above and slightly forward; side cards fan out with rotation.
 * Every órgão logo (left side of each screen) stays fully visible.
 */
export default function PersonalizacaoStack() {
  return (
    <div className="relative w-full" style={{ paddingTop: "42%" }}>
      {LOGINS.map((l, i) => {
        // i=0 left, i=1 center (front), i=2 right
        const isCenter = i === 1;
        const rotate = i === 0 ? -6 : i === 2 ? 6 : 0;
        // Horizontal position — cards are 44% wide, spread evenly
        const leftPct = i === 0 ? 0 : i === 2 ? 56 : 28;
        const topPct = isCenter ? 0 : 12;
        const scale = isCenter ? 1 : 0.93;
        // Progressive z-index so every órgão logo (left side of each card)
        // sits above the previous card's right side (form area).
        const zIndex = 10 + i * 10;

        return (
          <motion.div
            key={l.id}
            initial={{ opacity: 0, y: 40, rotate: 0 }}
            animate={{ opacity: 1, y: 0, rotate, scale }}
            transition={{
              duration: 0.75,
              delay: 0.1 + Math.abs(i - 1) * 0.14,
              ease: EASE,
            }}
            whileHover={{ y: -6, scale: scale + 0.02, zIndex: 40 }}
            style={{
              zIndex,
              left: `${leftPct}%`,
              top: `${topPct}%`,
              width: "44%",
              boxShadow: isCenter
                ? "0 34px 60px -24px rgba(26,58,97,0.32), 0 12px 24px -10px rgba(26,58,97,0.22)"
                : "0 22px 44px -22px rgba(26,58,97,0.24), 0 8px 18px -10px rgba(26,58,97,0.16)",
              transformOrigin: "center center",
            }}
            className="absolute rounded-lg overflow-hidden bg-white border border-[#1A3A61]/10"
          >
            <img
              src={l.src}
              alt={`Login personalizado, ${l.label}`}
              loading="lazy"
              className="w-full h-auto block"
            />
          </motion.div>
        );
      })}

      {/* Legend */}
      <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 z-40 hidden md:flex items-center gap-2 bg-white/95 backdrop-blur border hairline rounded-full px-3.5 py-1.5 shadow-sm">
        <span className="h-1.5 w-1.5 rounded-full bg-[#2EE59D]" />
        <span className="text-[11px] font-medium tracking-wide text-[#1A3A61]/80">
          Cada órgão, sua identidade
        </span>
      </div>
    </div>
  );
}
